import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { adminLogin } from "../lib/api";

const formatErr = (detail) => {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ");
  return String(detail);
};

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { token, user } = await adminLogin(email, password);
      localStorage.setItem("e2e_admin_token", token);
      localStorage.setItem("e2e_admin_user", JSON.stringify(user));
      nav("/admin");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login" className="min-h-screen bg-navy grain flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-10 h-10 rounded-full border border-gold/40 flex items-center justify-center text-gold"><Lock size={16} /></span>
          <div>
            <p className="overline text-gold">End to End Destinations</p>
            <h1 className="font-serif text-3xl text-ivory">Admin Console</h1>
          </div>
        </div>
        <form onSubmit={onSubmit} className="space-y-5 bg-navy/60 border border-ivory/10 p-8">
          <div>
            <label className="overline text-ivory/60 block mb-2">Email</label>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full bg-transparent border border-ivory/20 focus:border-gold text-ivory px-4 py-3 outline-none transition-colors"
              placeholder="admin@endtoenddestinations.com"
            />
          </div>
          <div>
            <label className="overline text-ivory/60 block mb-2">Password</label>
            <input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full bg-transparent border border-ivory/20 focus:border-gold text-ivory px-4 py-3 outline-none transition-colors"
              placeholder="••••••••"
            />
          </div>
          {error && <p data-testid="admin-login-error" className="text-red-300 text-sm">{error}</p>}
          <button
            type="submit" disabled={loading} data-testid="admin-login-submit"
            className="btn-gold w-full justify-center disabled:opacity-60"
          >
            {loading ? "Signing in…" : <>Sign In <ArrowRight size={16} /></>}
          </button>
        </form>
      </div>
    </main>
  );
}
